export default __webpack_public_path__ + "f4cee70ff19be61cedc80f3f35df17b7.png";